import { Stack, Text, Box, Button } from '@chakra-ui/react';
import { LogOut } from 'lucide-react';
import { useAuth } from 'provider';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATHS, stepperPages } from 'router/routes';

interface Props {
    title: string;
    description: string;
    children: React.ReactNode;
}

const CreateAgentFormWrapper = ({ title, description, children }: Props) => {
    const location = useLocation();
    const { signOut } = useAuth();
    const router = useNavigate();

    const onSignOut = () => {
        signOut();
        router(PATHS.SIGN_IN);
    };

    const step = useMemo(() => {
        return stepperPages.findIndex((step) => location.pathname.includes(step)) + 1;
    }, [location]);

    return (
        <div className='bg-gray-100'>
            <div className='min-h-screen flex flex-col items-center justify-center'>
                <div className='w-full max-w-6xl'>
                    <Stack
                        pb={{ base: '5', lg: '0' }}
                        alignItems='center'
                        position={{ base: 'initial', lg: 'absolute' }}
                        top={10}
                        right={10}
                    >
                        <Button variant='link' color='black' onClick={onSignOut} w='auto'>
                            <LogOut className='w-4 h-4 mr-2' />
                            Log out
                        </Button>
                    </Stack>
                    <div className='relative h-2 bg-gray-200 rounded-t-lg overflow-hidden'>
                        <div
                            className='absolute top-0 left-0 h-full bg-purple-600 transition-all duration-300 ease-in-out'
                            style={{ width: `${(step / stepperPages.length) * 100}%` }}
                        />
                    </div>
                    <Stack
                        backgroundColor='white'
                        border='1px solid'
                        borderColor='gray.200'
                        borderRadius='md'
                        spacing='0'
                    >
                        <Stack padding='1.5rem'>
                            <h3 className='text-2xl font-semibold leading-none tracking-tight'>{title}</h3>
                            <Text className='text-sm text-[#71717a]'>{description}</Text>
                        </Stack>
                        <Box px='1.5rem' pb='1.5rem'>
                            {children}
                        </Box>
                    </Stack>
                </div>
            </div>
        </div>
    );
};

export default CreateAgentFormWrapper;
